/// <summary>
/// This object provides js functions for error codes <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 10.11.2023<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 10.11.2023                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ErrorCodes", jQuery.common.VisualBase, {
    vcV: new vcVisual(),
    myHtml: null,
    myStructure: {
        codes: {
            obj: null, menu: null,
            ddlCodes: { obj: null, entries: null },
            list: { header: null, entries: null },
            data: null
        },
        form: {
            obj: null, menu: null,
            ddlCodes: { obj: null, entries: null },
            priorities: null,
            parameter: {
                name: null,
                errorid: null,
                status: null,
                priority: null,
                isApp: null,
                description: null,
                todo: null,
                errorcode: null
            },
            info: {
                description: null,
                todo: null
            },
        },
        selectedObj: null,
    },

    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 356;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            // inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
            me.myHtml = me.element.find(".error-codes");

            me._initTriggers();
            me._buildHtml();

            // get/update the table of error codes
            me._updateCodesList();

            // fill the dropdown list to select the priority of an error
            me._fillDdlPrios();

            // fill both dropdown lists with all saved error codes
            me._updateDdlCodes();

            return true;
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me.fnd("#div-btn-new").button().off("click").on("click", function () {
                me._clearForm();
                me.element.trigger({ type: "switch-between-list-and-form" });
            });

            me.fnd("#div-btn-back").button().off("click").on("click", function () {
                $("#selectCodes-codes").prop("selectedIndex", 0);
                me.element.trigger({ type: "switch-between-list-and-form" });
            });

            me.fnd("#div-btn-save").button().off("click").on("click", function () {
                me._saveErrorCode();
                $("#selectCodes-codes").prop("selectedIndex", 0);
                me.element.trigger({ type: "switch-between-list-and-form" });
                me._updateDdlCodes();
            });

            me.myStructure.codes.ddlCodes.off("change").on("change", function () {
                me._updateCodesList();
            });

            me.myStructure.form.ddlCodes.off("change").on("change", function () {
                me._updatePreviewErrorCode();
            });

            me.myStructure.form.parameter.errorid.off("change").on("change", function () {
                me._updatePreviewErrorCode();
            });

            me.fnd("#div-codes-data", ".btn-del").off("click", ".btn-del").on("click", ".btn-del", function (e) {
                me._deleteErrorCode(me.myStructure.codes.data.rows[$(this)[0].id]);
                me._updateCodesList();
                e.stopPropagation();
            });

            me.visual.find("#div-codes-data", ".vc-list-item").off("click", ".vc-list-item").on("click", ".vc-list-item", function () {
                me.myStructure.form.selectedObj = me.myStructure.codes.data.rows[$(this).index()];
                me._showEntry();
                me.element.trigger({ type: "switch-between-list-and-form" });
                me._setParentDdlCode(me.myStructure.form.selectedObj.parent);
            });

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }

        return true;
    },

    _initTriggers: function () {
        var me = this;
        try {

            me.element.on("switch-between-list-and-form", function (e) {
                if ($(me.myStructure.codes).is(":visible")) {
                    me.myStructure.codes.hide();
                    me.myStructure.form.show();
                }
                else {
                    me._fillDdlCodes(false);
                    me.myStructure.codes.show();
                    me.myStructure.form.hide();
                    me._updateCodesList();
                }                
            });

        } catch (e) {
            me.writeError('_initTriggers', e);
            return false;
        }

    },

    _buildHtml: function () {
        var me = this;
        try {
            let obj = null;

            //----------------------------------LIST OF CODES----------------------------------------
            me.myStructure.codes = $("<div>").attr("id", "div-codes");
            obj = me.myStructure.codes;

            // header of list / columns
            obj.menu = $("<div>").attr("id", "div-codes-menu").addClass("vc-grid-margin-bottom");
            obj.list = $("<div>").attr("id", "div-codes-list").addClass("vc-list");
            obj.header = $("<div>").attr("id", "div-codes-header").addClass("vc-list-header color-bg-secondary");
            obj.entries = $("<div>").attr("id", "div-codes-entries").addClass("vc-list-table");
            obj.list.append(obj.header);

            var divBtnNew = $("<div>").attr("id", "div-btn-new").addClass("button-toggle float-r").html(me.specific.resources.new);
            obj.find(".button-toggle").button();

            obj.ddlCodes = $("<div>").attr("id", "txt-ddl-codes").addClass("ddl-codes");

            obj.menu.append(divBtnNew, obj.ddlCodes);
            obj.menu.append($("<div>").attr("style", "clear:both"));
            obj.menu.append("<hr/>");

            // list with data
            var l = $("<div>").addClass("vc-list-item");
            var c = $("<div>").addClass("vc-list-col");
            l.append(c);
            c.append($("<div>").addClass("vc-list-col-element col0").html("ID"));
            c.append($("<div>").addClass("vc-list-col-element col1").html(me.specific.resources.active));
            c.append($("<div>").addClass("vc-list-col-element col2").html("Code"));            
            c.append($("<div>").addClass("vc-list-col-element col3").html(me.specific.resources.name));            
            c.append($("<div>").addClass("vc-list-col-element col4").html(me.specific.resources.priority));
            c.append($("<div>").addClass("vc-list-col-element col5"));
            obj.header.append(l);

            obj.data = $("<div>").attr("id", "div-codes-data").addClass("lst-entries vc-list-table");
            obj.entries.append(obj.data);
            obj.list.append(obj.entries);

            obj.append(obj.menu, obj.list);

            //---------------------------FORM TO ADD NEW CODES OR EDIT CODES-------------------------------
            me.myStructure.form = $("<div>").attr("id", "div-form");
            obj = me.myStructure.form;

            obj.menu = $("<div>").attr("id", "div-form-menu").addClass("vc-grid-margin-bottom");

            var divBtnBack = $("<div>").attr("id", "div-btn-back").addClass("button-toggle float").html(me.specific.resources.back);

            var divBtnSave = $("<div>").attr("id", "div-btn-save").addClass("button-toggle float-r").html(me.specific.resources.save);
            obj.find(".button-toggle").button();            

            obj.menu.append(divBtnBack, divBtnSave);
            obj.menu.append($("<div>").attr("style", "clear:both"));
            obj.menu.append("<hr/>");

            //------------------------------PARAMETER box----------------------------------------------------
            obj.parameter = $("<fieldset>").addClass("formFieldset box col1 vc-grid-margin-bottom").append($("<legend>").text(me.specific.resources.parameter));

            // input field for status
            var statusField = $("<div>").attr("id", "div-item-status").addClass("formItem chbItem type-text");
            obj.parameter.status = $("<input>").attr("id", "chb-status").addClass("chb").attr("checked", "checked").attr("type", "checkbox");
            statusField.append(obj.parameter.status);
            statusField.append($("<div>").addClass("chb-caption highlight").text(me.specific.resources.active));

            // input field for isApp
            var isAppField = $("<div>").attr("id", "div-item-isApp").addClass("formItem chbItem type-text");
            obj.parameter.isApp = $("<input>").attr("id", "chb-isApp").addClass("chb ").attr("checked", "checked").attr("type", "checkbox");
            isAppField.append(obj.parameter.isApp);
            isAppField.append($("<div>").addClass("chb-caption").text(me.specific.resources.application));

            // input field for errorid
            var errorIDField = $("<div>").attr("id", "div-item-errorid").addClass("formItem float formItemValid type-text").append($("<div>").addClass("caption").text("Error ID"));
            obj.parameter.errorid = $("<input>").attr("id", "txt-errorid").addClass("value large ");
            errorIDField.append(obj.parameter.errorid);

            // text field for errorcode
            var previewField = $("<div>").attr("id", "div-item-errorcode").addClass("formItem float formItemValid type-text").append($("<div>").addClass("caption").text(me.specific.resources.preview));
            obj.parameter.errorcode = $("<div>").attr("id", "txt-errorcode").addClass("type-text");
            previewField.append(obj.parameter.errorcode);

            // dropdown list for priority
            var priorityField = $("<div>").attr("id", "div-item-priority").addClass("formItem float formItemValid type-select").append($("<div>").addClass("caption").text(me.specific.resources.priority));
            obj.parameter.priority = $("<div>").attr("id", "txt-priority").addClass("value large ddl-parameter");
            priorityField.append(obj.parameter.priority);

            // dropdown list for category (parent error code)
            var categoryField = $("<div>").attr("id", "div-item-category").addClass("formItem float formItemValid type-select").append($("<div>").addClass("caption").text("Kategorie"));
            obj.ddlCodes = $("<div>").attr("id", "txt-ddl-form").addClass("ddl-parameter");
            categoryField.append(obj.ddlCodes);

            //------------------------------INFO box----------------------------------------------------
            obj.info = $("<fieldset>").addClass("formFieldset box col1 vc-grid-margin-bottom").append($("<legend>").text(me.specific.resources.info));

            // input field for name
            var nameField = $("<div>").attr("id", "div-item-name").addClass("formItem float formItemValid type-text").append($("<div>").addClass("caption").text(me.specific.resources.name));
            obj.parameter.name = $("<input>").attr("id", "txt-name").addClass("value large ");
            nameField.append(obj.parameter.name);

            // input area for description
            var descriptionField = $("<div>").attr("id", "div-editor").addClass("formItem float formItemValid type-text").append($("<div>").addClass("caption").text(me.specific.resources.description));
            var descriptionBox = $("<div>").attr("id", "div-description").addClass("value readonly textbox");
            obj.parameter.description = $("<textarea>").attr("id", "area-description").addClass("value textarea");
            descriptionBox.append(obj.parameter.description);
            descriptionField.append(descriptionBox);

            // input area for todo
            var todoField = $("<div>").attr("id", "div-editor-todo").addClass("formItem float formItemValid type-text").append($("<div>").addClass("caption").text("Todo"));
            var todoBox = $("<div>").attr("id", "div-todo").addClass("value readonly textbox");
            obj.parameter.todo = $("<textarea>").attr("id", "area-todo").addClass("value textarea");
            todoBox.append(obj.parameter.todo);
            todoField.append(todoBox);

            obj.info.append(nameField, descriptionField, todoField);

            obj.parameter.append(statusField, isAppField, errorIDField, priorityField, categoryField, previewField);

            obj.append(obj.menu, obj.parameter, obj.info);

            me.myHtml.append(me.myStructure.codes, me.myStructure.form);
         
        } catch (e) {
            me.writeError('_buildHtml', e);
            return false;
        }
        return true;
    },

    _fillDdlPrios: function () {
        /// <summary>
        /// This function gets the data from the db and fills the dropdown list with the priorities
        /// </summary>
        var me = this;

        try {
            var param = {};
            param.TypeId = 1;

            me.getData(param, function (result) {

                let obj = me.myStructure.form;
                obj.priorities = result;
                var selection = $("<select>").attr("id", "selectPrios").addClass("select-prios text-margin ddl-select");

                for (var i = 0; i < result.length; i++) {
                    selection.append($("<option>").attr("value", obj.priorities[i]).html("Level " + obj.priorities[i]));
                }

                obj.parameter.priority.append(selection);
            });

        } catch (e) {
            me.writeError('_fillDdl', e);
            return false;
        }

    },

    _updateDdlCodes: function () {
        /// <summary>
        /// This function updates the dropdown lists with the error codes
        /// </summary>
        var me = this;
        try {
            me._fillDdlCodes(false);
            me._fillDdlCodes(true);
        } catch (e) {
            me.writeError('_updateDdlCodes', e);
            return false;
        }
    },

    _fillDdlCodes: function (formView) {
        /// <summary>
        /// This function gets the data from the db and fills the dropdown list with all saved error codes
        /// </summary>
        var me = this;
        try {
            var substring = "codes";
            var htmlString = me.specific.resources.selection + ":";
            var additionalClass = "ddl";
            var param = {};
            param.TypeId = 2;

            me.getData(param, function (result) {

                let obj = me.myStructure.codes;
                if (formView) {
                    obj = me.myStructure.form;
                    substring = "form";
                    htmlString = "";
                    additionalClass = "ddl-select";
                }

                obj.ddlCodes.entries = result;

                if (result.rows.length > 1) {
                    obj.ddlCodes.html(htmlString);

                    var selection = $("<select>").attr("id", "selectCodes-" + substring).addClass(additionalClass).addClass(" text-margin");

                    for (var i = 0; i < result.rows.length; i++) {
                        selection.append($("<option>").attr("value", i).html(result.rows[i].code));
                    }

                    obj.ddlCodes.append(selection);
                }
            });

        } catch (e) {
            me.writeError('_fillDdlCodes', e);
            return false;
        }
    },

    _updateCodesList: function () {
        /// <summary>
        /// This function gets the data from the db and updates the error codes list in the chart
        /// </summary>
        var me = this;
        try {
            me._initList(true);
            var param = {};

            var ddlIndex = me.element.find("#selectCodes-codes option:selected").val();

            // if special error code is selected in dropdown list, error code list is filtered
            if (ddlIndex > 0) {
                param.ddlIndex = me.myStructure.codes.ddlCodes.entries.rows[ddlIndex].id;
            }            

            // get data from db
            me.getData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }

                // fill list with data
                me.myStructure.codes.data = result;

                me._generateList();

                return true;
            });
        } catch (e) {
            me.writeError('_updateCodesList', e);
            return false;
        }
    },

    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data and fills the error code table
        /// </summary>
        var me = this;

        try {

            var list = me._initList(false);

            let obj = me.myStructure.codes.data;

            if (obj === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            if (obj.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            // fill error code table with items
            for (var i = 0; i < obj.rows.length; i++) {
                var item = $("<div>", { "class": "vc-list-item" });
                item.append($("<div>", { "class": "vc-list-col col0" }).html($("<td>", { "class": "vc-list-col-element", "html": obj.rows[i].id })));
                item.append($("<div>", { "class": "vc-list-col col1" }).html($("<i>", { "class": "vc-list-col-element vc-list-icon fa fa-power-off " + me._convertState(obj.rows[i].active) })));
                item.append($("<div>", { "class": "vc-list-col col2" }).html($("<td>", { "class": "vc-list-col-element", "html": me._checkIfEmpty(obj.rows[i].errorcode) })));
                item.append($("<div>", { "class": "vc-list-col col3" }).html($("<td>", { "class": "vc-list-col-element", "html": me._checkIfEmpty(obj.rows[i].name) })));
                item.append($("<div>", { "class": "vc-list-col col4" }).html($("<td>", { "class": "vc-list-col-element txtalign-c", "style": "width: 100%; text-align: center" , "html": obj.rows[i].priority })));
                item.append($("<div>", { "class": "vc-list-col col5 txtalign-r" }).html($("<i>", { "class": "choice-clear-single fa fa-times vc-list-icon icon-color-error btn-del", "id": i })));
                list.append(item);
            }

            me._formatTable();

            return true;
        } catch (e) { me.writeError('_generateList', e); return false; }
    },

    _checkIfEmpty: function (value) {
        /// <summary>
        /// This function checks if a saved entry is an empty string
        /// </summary>
        var me = this;
        try {
            if (value == "")
                return "-";
            else
                return value;

        } catch (e) { me.writeError('_checkIfEmpty', e); return false; }
    },

    _convertState: function (active) {
        /// <summary>
        /// This function checks the status of an error code and corresponding icon (active/inactive) is shown
        /// </summary>
        var me = this;
        try {
            if (active)
                return "icon-color-ok";
            else
                return "icon-color-error";

        } catch (e) { me.writeError('_convertState', e); return false; }
    },

    _initList: function (showIcon) {
        var me = this;
        try {

            var list = me.fnd(".lst-entries");

            if (showIcon)
                return list.html(me.getLoadingIcon()); // show loading icon
            else
                return list.html("");

        } catch (e) { me.writeError('_initList', e); return false; }
    },

    _formatTable: function () {
        var me = this;
        try {
            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
        } catch (e) { me.writeError('_formatTable', e); return false; }
    },

    _saveErrorCode: function () {
        /// <summary>
        /// This function saves the current error code entry in the db
        /// It is called by clicking on the save button
        /// </summary>
        var me = this;
        try {
            var itemid = 0;

            let obj = me.myStructure.form.parameter;
            var entry = {};

            entry.Name = obj.name.val();
            entry.ErrorId = obj.errorid.val();
            entry.Priority = me.element.find(".select-prios option:selected").val();
            entry.Active = $(obj.status).is(":checked");
            entry.Description = obj.description.val();
            entry.Todo = obj.todo.val();
            entry.IsApp = $(obj.isApp).is(":checked");

            if (me.myStructure.form.selectedObj != null) // existing entry is loaded -> only update the entry;  
                itemid = me.myStructure.form.selectedObj.id;

            var ddlIndex = me.element.find("#selectCodes-form option:selected").val()
            if (ddlIndex > 0)
                entry.Parent = me.myStructure.form.ddlCodes.entries.rows[ddlIndex].id;
            else
                entry.Parent = 0;

            var param = { TypeId: 0, ItemId: itemid, Entry: entry };

            window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
                function (result) {
                    if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
                    return true;
                });

        } catch (e) { me.writeError('_saveErrorCode', e); return false; }

    },

    _deleteErrorCode: function (obj) {
        /// <summary>
        /// This function deletes the selected error code entry from the db 
        /// It is called by clicking on the delete icon
        /// </summary>
        var me = this;
        try {
            var param = { TypeId: 1, ItemId: obj.id };

            window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
                function (result) {
                    if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
                    return true;
                });

            me._updateCodesList();

        } catch (e) { me.writeError('_deleteErrorCode', e); return false; }
    },

    _clearForm: function () {
        /// <summary>
        /// This function resets the input form for a new error code entry
        /// </summary>
        var me = this;
        try {
            let obj = me.myStructure.form.parameter;
            obj.name.val("");
            obj.errorid.val("");
            $(obj.status)[0].checked = true;
            obj.description.val("");
            obj.todo.val("");
            $(obj.isApp)[0].checked = false;

            // fill default error code, if error code is selected in dropdown list
            var ddlIndex = me.element.find("#selectCodes-codes option:selected").val();

            if (ddlIndex > 0)
            {
                var selectedCode = me.myStructure.codes.ddlCodes.entries.rows[ddlIndex].code;
                obj.errorcode.text(selectedCode);
            }
            else
                obj.errorcode.text("-");

            $("#selectPrios").prop("selectedIndex", 0);

            me.myStructure.form.selectedObj = null;

            var ddlIndex = me.element.find("#selectCodes-codes option:selected").val();
            $("#selectCodes-form").prop("selectedIndex", ddlIndex);

        } catch (e) { me.writeError('_clearForm', e); return false; }
    },

    _showEntry: function () {
        /// <summary>
        /// This function loads the saved data of a selected error code
        /// </summary>
        var me = this;
        try {
            let loadedObj = me.myStructure.form.parameter;
            let selectedObj = me.myStructure.form.selectedObj;
            loadedObj.name.val(selectedObj.name);
            loadedObj.errorid.val(selectedObj.errorid);
            loadedObj.errorcode.text(selectedObj.errorcode);

            var index = (parseInt(selectedObj.priority)) - 1;
            $("#selectPrios").prop("selectedIndex", index);

            $(loadedObj.status)[0].checked = selectedObj.active;
            loadedObj.description.val(selectedObj.description);
            loadedObj.todo.val(selectedObj.todo);
            $(loadedObj.isApp)[0].checked = selectedObj.isApp;

        } catch (e) {
            me.writeError('_showEntry', e);
            return false;
        }
    },

    _setParentDdlCode: function (parentId) {
        /// <summary>
        /// This function loads and sets the saved parent error code in the dropdown list
        /// </summary>
        var me = this;
        try {
            if (parentId > 0) {
                for (var i = 0; i < me.myStructure.form.ddlCodes.entries.rows.length; i++) {
                    if (me.myStructure.form.ddlCodes.entries.rows[i].id == parentId) {
                        $("#selectCodes-form").prop("selectedIndex", i); // set to saved parent ddl code
                    }                    
                }
            }
            else
                $("#selectCodes-form").prop("selectedIndex", 0); // set to "all" - no parent code is existing

        } catch (e) { me.writeError('_setParentDdlCode', e); return false; }
    },

    _updatePreviewErrorCode: function () {
        /// <summary>
        /// This function updates the preview of the final error code
        /// Final error code is updated, if parent error code or current error id is changed
        /// </summary>
        var me = this;
        try {
            let obj = me.myStructure.form;

            var ddlIndex = me.element.find("#selectCodes-form option:selected").val();
            var previewString = "";
            if (ddlIndex > 0)
                previewString += obj.ddlCodes.entries.rows[ddlIndex].code + ".";

            previewString += obj.parameter.errorid.val();

            obj.parameter.errorcode.text(previewString);

        } catch (e) { me.writeError('_updatePreviewErrorCode', e); return false; }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-codes").hide();
                me.fnd("#div-form").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }
});





